import React from 'react';
import { Link, Navigate, useLocation } from 'react-router';
import { useAuth } from '../../context/AuthContext';
import { buildSignInPath } from '../../utils/authFlow';
import LoadingSpinner from '../LoadingSpinner';
function hasAllowedRole(roles, allowedRoles) {
    return allowedRoles.some(role => Boolean(roles?.[role]));
}
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
    const { user, isAuthenticated, isLoading } = useAuth();
    const location = useLocation();
    if (isLoading) {
        return React.createElement(LoadingSpinner, { message: "Checking access..." });
    }
    if (!isAuthenticated) {
        const returnUrl = `${location.pathname}${location.search}`;
        return React.createElement(Navigate, { replace: true, to: buildSignInPath(returnUrl, 'protected') });
    }
    if (allowedRoles.length > 0 && !hasAllowedRole(user?.roles, allowedRoles)) {
        return (React.createElement("section", { className: "panel panel-warning wt-access-message", role: "alert" },
            React.createElement("div", { className: "panel-body" },
                React.createElement("div", { className: "wt-access-message-icon", "aria-hidden": "true" },
                    React.createElement("i", { className: "fa fa-lock" })),
                React.createElement("h2", null, "Access restricted"),
                React.createElement("p", null, "Your account does not have the role required to use this page."),
                React.createElement(Link, { className: "btn btn-default", to: "/" }, "Return Home"))));
    }
    return React.createElement(React.Fragment, null, children);
};
export default ProtectedRoute;
